export const T={
  bgBase:'#070c12',bgPanel:'#0d1520',bgPanel2:'#111e2d',
  borderFaint:'#1a2a3a',borderMid:'#1e3040',borderInput:'#243545',
  textPrimary:'#e8f0f8',textSecond:'#a0b4c8',textMuted:'#5a7a8a',
  blue:'#4dc8f0',blueD:'#1a6a9a',
  green:'#3de89a',greenD:'#1a7a4a',
  red:'#f06070',redD:'#8a2030',
  amber:'#f0c040',amberD:'#8a6010',
};

export const GS=`
  *{box-sizing:border-box;margin:0;padding:0;}
  body{background:${T.bgBase};color:${T.textPrimary};font-family:'DM Sans',-apple-system,sans-serif;font-size:14px;line-height:1.5;-webkit-font-smoothing:antialiased;}
  input,select,textarea{font-family:inherit;}
  .cmd-input{width:100%;padding:9px 14px;background:${T.bgPanel2};border:1px solid ${T.borderInput};border-radius:8px;color:${T.textPrimary};font-size:14px;font-family:'DM Sans',sans-serif;outline:none;transition:border-color .15s;}
  .cmd-input:focus{border-color:${T.blueD};}
  .num-input{padding:7px 10px;background:${T.bgPanel2};border:1px solid ${T.borderInput};border-radius:6px;color:${T.textPrimary};font-size:13px;font-family:'DM Mono',monospace;outline:none;width:100%;}
  .num-input:focus{border-color:${T.blueD};}
  .auth-input{width:100%;padding:12px 16px;background:${T.bgPanel2};border:1px solid ${T.borderInput};border-radius:10px;color:${T.textPrimary};font-size:15px;font-family:'DM Sans',sans-serif;outline:none;transition:border-color .15s;}
  .auth-input:focus{border-color:${T.blueD};}
  .tab-btn{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;padding:10px 8px 8px;border:none;border-bottom:2px solid transparent;background:transparent;color:${T.textMuted};cursor:pointer;font-family:'DM Sans',sans-serif;font-size:11px;font-weight:500;white-space:nowrap;transition:all .15s;min-width:64px;flex:0 0 auto;}
  .tab-btn:hover{color:${T.textSecond};background:rgba(255,255,255,.03);}
  .tab-btn.active{color:${T.blue};border-bottom:2px solid ${T.blue};background:rgba(77,200,240,.04);}
  .tab-ic{font-size:18px;line-height:1;}
  .tab-label{font-size:11px;letter-spacing:.01em;}
  .desktop-tab-row::-webkit-scrollbar{display:none;}
  @keyframes spin{to{transform:rotate(360deg);}}
  @keyframes fadeUp{from{opacity:0;transform:translateX(-50%) translateY(10px);}to{opacity:1;transform:translateX(-50%) translateY(0);}}
  ::-webkit-scrollbar{width:4px;height:4px;}
  ::-webkit-scrollbar-track{background:transparent;}
  ::-webkit-scrollbar-thumb{background:${T.borderMid};border-radius:99px;}
`;

export const FREE_FOREVER=['david@andcap.com.au','keagan@heartledsupport.com','paul@theqldgroup.com.au','glenn@heartledsupport.com','blase@blasegrinner.com','rob@coffeeroastersco.com.au','jeb@heartledsupport.com','yan@theqldgroup.com.au','wand4553@bigpond.net.au','chris@apdnsw.com.au','andrea@andreatindiani.com','drdavid@hendreychiropractic.com.au','trent.daniel@azupay.com.au','joe@premierandco.com.au','dylan@premierandco.com.au','casewarwick@gmail.com','steve@locomotiveparts.com.au'];
export const TRIAL_DAYS=7;

export const LEVELS=[
  {l:1,t:'Recruit',xp:0,desc:'You have entered the arena.'},
  {l:2,t:'Operative',xp:200,desc:'Systems are online. Daily discipline beginning.'},
  {l:3,t:'Executor',xp:600,desc:'Action is your default state.'},
  {l:4,t:'Tactician',xp:1500,desc:'You plan, you move, you execute.'},
  {l:5,t:'Strategist',xp:3000,desc:'You see the board others miss.'},
  {l:6,t:'Director',xp:5000,desc:'You run the operation with precision.'},
  {l:7,t:'Commander',xp:8000,desc:'Others follow your lead.'},
  {l:8,t:'Architect',xp:12000,desc:'You design the systems others live inside.'},
  {l:9,t:'Principal',xp:18000,desc:'Capital, influence, and leverage — all compounding.'},
  {l:10,t:'Sovereign',xp:30000,desc:'Complete financial and personal autonomy. Reserved for the most disciplined operators.'},
  {l:11,t:'Apex',xp:50000,desc:'Top 0.1% of operators. The standard others aim for.'},
  {l:12,t:'Titan',xp:75000,desc:'Your trajectory is generational.'},
  {l:13,t:'Legend',xp:110000,desc:'The work speaks. Nothing left to prove.'},
  {l:14,t:'Immortal',xp:150000,desc:'Built something that outlasts you.'},
];

export const getLevel=(xp)=>{
  let current=LEVELS[0],next=LEVELS[1]||null;
  for(let i=0;i<LEVELS.length;i++){if(xp>=LEVELS[i].xp){current=LEVELS[i];next=LEVELS[i+1]||null;}}
  if(!next){
    let base=150000,l=14;
    while(xp>=base){base=Math.round(base*1.4);l++;}
    const prevBase=Math.round(base/1.4);
    current={l,t:`Apex ${l-13}`,xp:prevBase,desc:'Beyond the chart. Truly elite.'};
    next={l:l+1,t:`Apex ${l-12}`,xp:base,desc:'The next summit.'};
  }
  return{c:current,n:next};
};

export const DEFAULT_HABITS=[
  {k:'exercise',l:'Exercise',pts:3,ic:'🏃',cat:'Body'},
  {k:'hydration',l:'Hydration 2.5L+',pts:2,ic:'💧',cat:'Body'},
  {k:'sleep',l:'Sleep 7hrs+',pts:2,ic:'😴',cat:'Body'},
  {k:'meditation',l:'Meditation',pts:2,ic:'🧘',cat:'Mind'},
  {k:'reading',l:'Reading',pts:1,ic:'📚',cat:'Mind'},
  {k:'noAlcohol',l:'No Alcohol',pts:2,ic:'🚫',cat:'Body'},
  {k:'journaling',l:'Journaling',pts:1,ic:'✍️',cat:'Mind'},
  {k:'noSugar',l:'No Sugar',pts:2,ic:'🍬',cat:'Body'},
  {k:'coldShower',l:'Cold Shower',pts:1,ic:'🚿',cat:'Body'},
  {k:'gratitude',l:'Gratitude practice',pts:1,ic:'🙏',cat:'Mind'},
  {k:'networking',l:'One relationship touch',pts:2,ic:'🤝',cat:'Growth'},
  {k:'learning',l:'Learning / course',pts:2,ic:'🎓',cat:'Growth'},
  {k:'savings',l:'Checked savings goal',pts:1,ic:'💰',cat:'Finance'},
  {k:'noSocial',l:'No social media',pts:2,ic:'📵',cat:'Mind'},
  {k:'walking',l:'10,000 steps',pts:2,ic:'👟',cat:'Body'},
];
export const HABITS=DEFAULT_HABITS.slice(0,6);

export const ACHIEVEMENTS=[
  {id:'first_task',ic:'⚡',l:'First Strike',d:'Complete your first task',xp:10},
  {id:'cashflow_set',ic:'📊',l:'Cash Command',d:'Set up your cashflow',xp:25},
  {id:'wealth_logged',ic:'🗺',l:'Net Worth Mapped',d:'Log your net worth',xp:25},
  {id:'habit_50',ic:'🔒',l:'Locked In',d:'Score 50+ habit points',xp:40},
  {id:'habit_perfect',ic:'💎',l:'Perfect Week',d:'Score all habit points in a week',xp:100},
  {id:'bill_paid',ic:'✅',l:'Cleared',d:'Mark a bill as paid',xp:15},
  {id:'p1_sweep',ic:'🗂',l:'Full Sweep',d:'Complete all P1 tasks',xp:50},
  {id:'streak_7',ic:'🏅',l:'7-Day Habit',d:'Exercise 7 days straight',xp:70},
  {id:'first_goal',ic:'🎯',l:'On Target',d:'Set your first goal',xp:20},
  {id:'first_journal',ic:'📓',l:'First Entry',d:'Write your first journal entry',xp:10},
  {id:'goal_milestone',ic:'🏆',l:'Milestone Hit',d:'Complete a goal milestone',xp:30},
  {id:'journal_7',ic:'✍️',l:'7-Day Journal',d:'Journal 7 days running',xp:50},
];

export const GOAL_CATS=[{k:'wealth',l:'Wealth',ic:'💰',color:'#3de89a'},{k:'business',l:'Business',ic:'🏢',color:'#4dc8f0'},{k:'health',l:'Health',ic:'💪',color:'#f06090'},{k:'family',l:'Family',ic:'👨‍👩‍👧',color:'#f0c040'},{k:'personal',l:'Personal',ic:'🌱',color:'#b06af0'}];
export const JOURNAL_PROMPTS=['What am I actively building toward today?','One thing I am grateful for right now.','Free thoughts — anything on your mind.'];

export const WEALTH_ACTIONS=[
  {area:'Revenue',action:'Follow up one outstanding invoice or advisory fee'},
  {area:'Pipeline',action:'Identify one new revenue or client opportunity'},
  {area:'Cashflow',action:'Confirm this week\'s income has landed'},
  {area:'Investing',action:'Review investment positions — add if cashflow allows'},
  {area:'Debt',action:'Check liability balances — any opportunity to reduce faster?'},
  {area:'Net Worth',action:'Update asset values in the Wealth tab'},
  {area:'Goals',action:'Review your top goal — are daily actions on track?'},
];

export const REWARD_TIERS=[
  {id:'recognition',l:'Recognition',ic:'🎖',color:'#4dc8f0',desc:'Your rank is earned. Your progress is permanent. These markers follow you through the system.',available:true,
    rewards:[
      {xp:0,l:'Founding Member — permanent',d:'You were here at the start. This status is never available to later signups. Permanent. Non-transferable.',available:true},
      {xp:500,l:'Dynamic level titles',d:'14 ranked titles from Recruit to Immortal — updated automatically as your XP grows. Your title is visible to your buddy.',available:true},
      {xp:1500,l:'Achievement badges',d:'Unlock badges for key milestones. Displayed on your Command tab. Each one represents something you actually did.',available:true},
      {xp:8000,l:'Commander recognition',d:'Commander rank and above will receive priority recognition in future COMMAND community features.',available:true},
    ]},
  {id:'insider',l:'COMMAND Insider',ic:'⭐',color:'#3de89a',desc:'Reserved for operators who show up consistently. These rewards carry genuine value and cost nothing but sustained commitment.',available:true,
    rewards:[
      {xp:800,l:'Early feature access',d:'Every new COMMAND feature hits your account before public release. You shape what gets built. Feedback from early access members directly influences the roadmap.',available:true},
      {xp:2000,l:'Monthly Financial Operator brief',d:'CFO-grade thinking from the COMMAND team — capital strategy, tax positioning, investment frameworks. Direct to your inbox. Not available publicly.',available:true,claim:'COMMAND Insider Brief — XP 2000 unlock'},
      {xp:5000,l:'Direct line to the founder',d:'At Director rank you have earned direct access. Questions, ideas, feedback — reply to any COMMAND email and it goes straight to David Andrews. Not a support queue. A real conversation.',available:true,claim:'COMMAND Direct Access — XP 5000 unlock'},
      {xp:8000,l:'Community founding seat',d:'When COMMAND community features launch — operator networks, peer accountability — you are first in. Your commitment earns your place at the front.',available:true,claim:'COMMAND Community Seat — XP 8000 unlock'},
    ]},
  {id:'partners',l:'COMMAND Partner Rewards',ic:'🎁',color:'#f0c040',desc:'We are building the partner network as the COMMAND community grows. The bigger the community, the more leverage we have. Qualifying members will be contacted directly.',available:true,comingSoon:'Coming',
    rewards:[
      {xp:5000,l:'Travel & stays',d:'Premium accommodation and travel rewards for operators who have earned the upgrade. Partners being confirmed. Director rank and above qualify when this launches.',available:false,comingSoon:'Coming'},
      {xp:10000,l:'Performance & sport',d:'Elite gear and sport rewards for operators who train as hard as they work. Leading brands being confirmed. Details announced to qualifying members.',available:false,comingSoon:'Coming'},
      {xp:18000,l:'Everyday savings',d:'Meaningful savings on fuel, groceries, and daily essentials. Because operators at this level should pay less for what they buy every week.',available:false,comingSoon:'Coming'},
      {xp:30000,l:'Sovereign recognition',d:'Fewer than 1 in 1,000 operators will reach this level. What that recognition looks like will be worthy of the achievement. We will reach out personally.',available:false,comingSoon:'Coming'},
    ]},
];

export const PLAN_CHECKLIST=[
  {id:'buffer',ic:'🛡',title:'Emergency buffer',priority:1,
   why:'3 months of living expenses in accessible cash. Non-negotiable. Without this, every financial decision is made under pressure.',
   rec:'Calculate your monthly expenses × 3. Check your current cash savings in the Wealth tab. The gap is your first target.',
   autoField:'cash_assets'},
  {id:'income_protection',ic:'💼',title:'Income protection insurance',priority:2,
   why:'Your ability to earn is your most valuable asset. One accident or illness without income protection can erase decades of wealth building.',
   rec:'Check if your super fund includes IP cover — most do at default levels that are too low. Get a quote for 75% of gross income to age 65. Priority over life cover.'},
  {id:'tpd_life',ic:'🔒',title:'TPD & life cover',priority:3,
   why:'Total Permanent Disability and life cover protects the people who depend on your income. Review what you have inside super first.',
   rec:'If you have dependants, benchmark cover at 10× annual income for life and enough TPD to eliminate all debt plus 5 years income. Industry super funds often provide this cheaply.'},
  {id:'super_review',ic:'🔵',title:'Superannuation fund review',priority:4,
   why:'Australians waste billions annually in excess super fees. The wrong fund costs you hundreds of thousands by retirement.',
   rec:'Under $250k: a high-performing industry fund with fees under 1% beats most retail options. Over $250k: model SMSF — but only if you will actively manage it.'},
  {id:'estate_planning',ic:'📋',title:'Estate planning',priority:5,
   why:'Without a current Will and POA, your estate may not go where you intend. Super does not automatically follow your Will.',
   rec:'Update your Will. Appoint an Enduring Power of Attorney. Update beneficiary nominations on all super accounts. Review every 3 years or on major life events.'},
  {id:'tax_structure',ic:'🏗',title:'Tax and ownership structure',priority:6,
   why:'The wrong structure costs you tax every year and creates asset protection gaps. The right structure is set up proactively.',
   rec:'Review with your accountant: does your income and asset profile justify a discretionary trust? A company? Are personal assets separated from business risk?'},
  {id:'bad_debt',ic:'✂',title:'Non-deductible debt eliminated',priority:7,
   why:'Credit cards, personal loans, and car loans at 8–20% interest are destroying wealth. Kill them before investing.',
   rec:'List all non-deductible debt in your Wealth tab. Prioritise by interest rate — highest first. Every dollar paying off a 20% credit card earns a guaranteed 20% return.'},
  {id:'offset',ic:'🏦',title:'Offset account maximised',priority:8,
   why:'Every dollar in your offset earns the equivalent of your mortgage rate — tax-free, risk-free. Best risk-adjusted return for most Australians.',
   rec:'Park all accessible savings in your offset before investing in anything returning less than your mortgage rate.'},
  {id:'super_contributions',ic:'📈',title:'Concessional super cap utilised',priority:9,
   why:'The $30,000/year concessional cap is taxed at 15% vs your marginal rate. Every dollar of salary sacrifice saves tax immediately.',
   rec:'Review your YTD super contributions. If below $30k, increase salary sacrifice before the financial year end.'},
  {id:'investment_allocation',ic:'📊',title:'Investment allocation reviewed',priority:10,
   why:'Most retail investors are overweight cash, underweight equities, and paying too much in fees. A simple index fund strategy outperforms most active management over 10 years.',
   rec:'Index fund core (ASX 200 + global ETF) at low fees (<0.25% MER). Dollar-cost average. Never time the market. Review allocation annually.'},
];

export const FW_ACTIONS=[
  {id:'setup_cashflow',l:'Set up your weekly cashflow',tab:'cashflow'},
  {id:'add_bill',l:'Add your first upcoming bill',tab:'bills'},
  {id:'set_goal',l:'Set your first goal',tab:'goals'},
  {id:'log_habit',l:'Log today\'s habits',tab:'habits'},
  {id:'update_wealth',l:'Log your net worth',tab:'wealth'},
];

export const TABS=[
  {id:'command',l:'Command',ic:'◈'},{id:'cashflow',l:'My Money',ic:'⬡'},
  {id:'forward',l:'Cashflow',ic:'◎'},{id:'bills',l:'Bills',ic:'≡'},
  {id:'wealth',l:'Wealth',ic:'◆'},{id:'plan',l:'My Plan',ic:'◉'},
  {id:'goals',l:'Goals',ic:'🎯'},{id:'journal',l:'Journal',ic:'📓'},
  {id:'habits',l:'Habits',ic:'○'},{id:'tasks',l:'Tasks',ic:'▣'},
  {id:'buddy',l:'Buddy',ic:'👥'},{id:'rewards',l:'Rewards',ic:'🎁'},
  {id:'settings',l:'Settings',ic:'⚙'},
];

// ─── UTILS ────────────────────────────────────────────────────────────────────
export const fmt=n=>{const a=Math.abs(Math.round(n));const s=a>=1000000?'$'+(a/1000000).toFixed(2)+'M':a>=1000?'$'+a.toLocaleString():'$'+a;return n<0?'-'+s:s;};
export const daysUntil=d=>{const t=new Date();t.setHours(0,0,0,0);const due=new Date(d);due.setHours(0,0,0,0);return Math.round((due-t)/86400000);};
export const getLvl=xp=>getLevel(xp);
export const todayIdx=()=>{const d=new Date().getDay();return d===0?6:d-1;};
export const fmtDate=d=>d.toLocaleDateString('en-AU',{day:'numeric',month:'short'});
export const getWkStart=(o=0)=>{const d=new Date();const dy=d.getDay();const df=dy===0?-6:1-dy;d.setDate(d.getDate()+df+o*7);d.setHours(0,0,0,0);return d;};
export const todayStr=()=>new Date().toISOString().split('T')[0];
export const monthsElapsed=from=>Math.max(0,Math.floor((new Date()-new Date(from))/(1000*60*60*24*30.44)));
export const daysSince=from=>Math.max(0,Math.floor((new Date()-new Date(from))/86400000));
export const tcol=t=>{if(t==='in')return{bg:'#081e14',color:'#3de89a',border:'#1a5a38'};if(t==='sweep')return{bg:'#081828',color:'#4dc8f0',border:'#1a4a6a'};if(t==='bill')return{bg:'#1e0808',color:'#f06070',border:'#6a1a28'};return{bg:'#0e1a24',color:'#7aaac8',border:'#1e3a52'};};

// Asset types — defined before makeDefault and calcNW so they're in scope
export const INVESTABLE_TYPES=['invested','super','property_investment','cash'];
export const ASSET_TYPE_LABELS={
  invested:'Shares & Investments',super:'Superannuation',
  property_investment:'Investment Property',property_home:'Primary Residence',
  cash:'Cash & Savings',business:'Business Equity',other:'Other Assets'
};
export const ASSET_GROWTH_RATES={
  invested:0.07,super:0.07,property_investment:0.04,
  property_home:0.04,cash:0.02,business:0.05,other:0.03
};

export const makeDefault=(setup={})=>({
  email:setup.email||'',
  income:{yours:setup.income||0,partner:setup.partnerIncome||0,other:0},
  openingBalance:setup.cashBalance||0,
  weeklyFixed:setup.weeklyFixed||[],weeklyInvestments:setup.weeklyInvestments||0,
  bills:[],assets:{items:setup.assetItems||[]},
  liabilities:{items:setup.liabilityItems||[],lastUpdated:todayStr()},
  goals:[],journal:[],
  tasks:[
    {id:1,text:'Update opening cash balance — check your bank app',pri:1,area:'Finance',done:false},
    {id:2,text:'Confirm this week\'s income has landed',pri:1,area:'Finance',done:false},
    {id:3,text:'Execute weekly investment sweeps',pri:1,area:'Finance',done:false},
    {id:4,text:'Review weekly net position',pri:1,area:'Finance',done:false},
  ],
  nextTaskId:5,
  habits:Object.fromEntries(DEFAULT_HABITS.map(h=>[h.k,[0,0,0,0,0,0,0]])),
  selectedHabits:DEFAULT_HABITS.slice(0,6).map(h=>h.k),
  customHabits:[],
  xp:25,level:1,achievements:[],cashflowEntries:0,
  onboarded:true,trialStart:new Date().toISOString(),joinedAt:new Date().toISOString(),
  freeForever:FREE_FOREVER.includes((setup.email||'').toLowerCase()),
  targetNW:setup.targetNW||0,targetYear:setup.targetYear||2035,
  planChecklist:{},
  habitXPLog:{},
});

// ─── ENGINES ──────────────────────────────────────────────────────────────────
export function getActiveHabits(S){
  const custom=(S.customHabits||[]).map(h=>({...h,pts:h.pts||1,ic:h.ic||'⭐',cat:'Custom'}));
  const selected=(S.selectedHabits||null);
  if(selected){
    const base=DEFAULT_HABITS.filter(h=>selected.includes(h.k));
    return[...base,...custom.filter(h=>selected.includes(h.k))];
  }
  return[...HABITS,...custom];
}

export function calcCF(S){
  const toWeekly=(v,f)=>{if(!v)return 0;switch(f){case'monthly':return v/4.33;case'fortnightly':return v/2;case'annual':return v/52;default:return v;}};
  const income=toWeekly(S.income?.yours||0,S.income?.yoursFreq||'weekly')+toWeekly(S.income?.partner||0,S.income?.partnerFreq||'weekly')+toWeekly(S.income?.other||0,'weekly');
  const fixed=(S.weeklyFixed||[]).reduce((s,x)=>s+(toWeekly(x.amount||0,x.freq||'weekly')),0);
  const inv=S.weeklyInvestments||0;
  const net=income-fixed-inv;
  const ob=S.openingBalance||0;
  const bills=S.bills||[];
  const fwd=Array.from({length:8},(_,i)=>{
    const wkBills=bills.filter(b=>{if(b.paid)return false;const d=daysUntil(b.due);return d>=i*7&&d<(i+1)*7;}).reduce((s,b)=>s+(b.amount||0),0);
    const bal=ob+(net*(i+1))-wkBills;
    return{week:i+1,balance:Math.round(bal),income:Math.round(income),bills:Math.round(wkBills),net:Math.round(net)};
  });
  const lowestBal=Math.min(...fwd.map(w=>w.balance));
  const dirs=[];
  const urg=(S.bills||[]).filter(b=>{if(b.paid)return false;const n=new Date();n.setHours(0,0,0,0);const d=new Date(b.due);d.setHours(0,0,0,0);return Math.round((d-n)/86400000)<=7;});
  urg.forEach(b=>dirs.push({day:'URGENT',type:'bill',acct:b.cat||'Bills',action:`Pay: ${b.name}`,amount:b.amount}));
  return{income,fixed,inv,net,fwd,dirs,urgBills:urg,lowestBal,cashAlert:lowestBal<0,surplusAlert:net<0,cashflowSetup:income>0||fixed>0};
}

export function calcNW(S){
  const items=S.assets?.items||[];
  const months=monthsElapsed(S.liabilities?.lastUpdated||todayStr());
  const liabs=(S.liabilities?.items||[]).reduce((l,x)=>l+Math.max(0,x.balance-(x.repayment*months)),0);
  const assets=items.reduce((s,a)=>s+(a.value||0),0);
  const investable=items.filter(a=>INVESTABLE_TYPES.includes(a.type||'other')).reduce((s,a)=>s+(a.value||0),0);
  const homeEquity=items.filter(a=>a.type==='property_home').reduce((s,a)=>s+(a.value||0),0);
  const businessEquity=items.filter(a=>a.type==='business').reduce((s,a)=>s+(a.value||0),0);
  const investableNet=Math.max(0,investable-liabs);
  return{assets,liabs,net:assets-liabs,investable,investableNet,homeEquity,businessEquity};
}

export function calcWealthAdvice(S,nw){
  const items=S.assets?.items||[];
  const advice=[];
  const totalInv=nw.investable||0;
  const cash=items.filter(a=>a.type==='cash').reduce((s,a)=>s+(a.value||0),0);
  const weeklyExpenses=(S.weeklyFixed||[]).reduce((s,x)=>s+x.amount,0);
  const threeMonthBuffer=weeklyExpenses*13;
  if(cash>threeMonthBuffer*2&&totalInv>0){
    const excess=Math.round(cash-threeMonthBuffer);
    advice.push({type:'warning',icon:'💸',title:'Cash drag detected',body:`You hold ${fmt(cash)} in cash. Beyond your 3-month buffer of ${fmt(threeMonthBuffer)}, the excess ${fmt(excess)} is earning minimal returns. Consider deploying into index funds or your offset account.`});
  }
  const bigAsset=items.filter(a=>INVESTABLE_TYPES.includes(a.type||'other')).find(a=>(a.value||0)>totalInv*0.6);
  if(bigAsset&&totalInv>50000){
    advice.push({type:'warning',icon:'⚠',title:'Portfolio concentration',body:`${bigAsset.name} represents more than 60% of your investable portfolio. Concentration risk increases volatility. Consider diversifying into index funds or other asset classes.`});
  }
  const superBalance=items.filter(a=>a.type==='super').reduce((s,a)=>s+(a.value||0),0);
  if(superBalance>0&&(S.income?.yours||0)>2000){
    advice.push({type:'opportunity',icon:'🔵',title:'Super concessional cap',body:`The concessional contribution cap is $30,000/year (FY2025). If you're not maximising salary sacrifice into super, the tax arbitrage is significant — contributions are taxed at 15% vs your marginal rate.`});
  }
  const ipEquity=items.filter(a=>a.type==='property_investment').reduce((s,a)=>s+(a.value||0),0);
  if(ipEquity>200000){
    advice.push({type:'opportunity',icon:'🏢',title:'Investment property equity',body:`You have ${fmt(ipEquity)} in investment property equity. A Line of Credit against this equity can fund further investments without selling.`});
  }
  if(nw.homeEquity>0){
    advice.push({type:'info',icon:'🏠',title:'Home equity excluded from target',body:`Your primary residence equity of ${fmt(nw.homeEquity)} is not counted toward your wealth target — it's a lifestyle asset. The correct path is via a PPOR Line of Credit to invest, not selling the home.`});
  }
  if(S.targetNW>0&&nw.investableNet>0){
    const yrs=Math.max(1,(parseInt(S.targetYear)||2035)-new Date().getFullYear());
    const projected=nw.investableNet*Math.pow(1.07,yrs)+((S.weeklyInvestments||0)*52)*((Math.pow(1.07,yrs)-1)/0.07);
    if(projected<S.targetNW){
      const gap=S.targetNW-projected;
      const extraWeekly=Math.round(gap/((Math.pow(1.07,yrs)-1)/0.07)/52);
      advice.push({type:'action',icon:'🎯',title:'Gap to target',body:`At current trajectory you will reach ${fmt(Math.round(projected))} by ${S.targetYear} — ${fmt(Math.round(gap))} short of your ${fmt(S.targetNW)} target. To close the gap: add ${fmt(extraWeekly)}/week to your investment sweeps.`});
    }
  }
  return advice;
}

export function calcScore(S,cf,nw){
  let s=0;
  if(cf?.cashflowSetup)s+=15;
  if(cf?.net>0)s+=20;
  const p1=S.tasks.filter(t=>t.pri===1);
  if(p1.length>0)s+=Math.round((p1.filter(t=>t.done).length/p1.length)*20);
  const active=getActiveHabits(S);
  const maxPts=active.reduce((t,h)=>t+h.pts*7,0)||84;
  const earned=active.reduce((t,h)=>t+(S.habits[h.k]||[0,0,0,0,0,0,0]).reduce((s,v)=>s+v*h.pts,0),0);
  if(maxPts>0)s+=Math.round((earned/maxPts)*20);
  if(nw&&S.targetNW>0)s+=Math.min(15,Math.round(((nw.investableNet||nw.net||0)/S.targetNW)*15));
  if((S.goals||[]).length>0)s+=5;
  const todayEntry=(S.journal||[]).find(j=>j.date===todayStr());
  if(todayEntry)s+=5;
  return Math.min(100,s);
}

export function getFWA(S,cf){
  return FW_ACTIONS.map(a=>({...a,done:
    a.id==='setup_cashflow'?(cf?.cashflowSetup||false):
    a.id==='add_bill'?(S.bills||[]).length>0:
    a.id==='set_goal'?(S.goals||[]).length>0:
    a.id==='log_habit'?getActiveHabits(S).some(h=>(S.habits[h.k]||[])[todayIdx()]>0):
    a.id==='update_wealth'?(S.assets?.items||[]).length>0:false
  }));
}

// ─── UI PRIMITIVES ────────────────────────────────────────────────────────────
export const Card=({children,style={},...p})=><div style={{background:T.bgPanel,border:`1px solid ${T.borderFaint}`,borderRadius:12,padding:'14px 16px',marginBottom:14,...style}} {...p}>{children}</div>;
export const Slab=({children,style={},...p})=><div style={{fontSize:11,fontWeight:700,color:T.textMuted,letterSpacing:'.1em',textTransform:'uppercase',marginBottom:10,...style}} {...p}>{children}</div>;
export const Row=({children,style={},...p})=><div style={{display:'flex',gap:10,alignItems:'center',padding:'8px 0',borderBottom:`1px solid ${T.borderFaint}`,...style}} {...p}>{children}</div>;
export const PBar=({pct,color,height=6,style={}})=><div style={{background:T.bgPanel2,borderRadius:99,height,overflow:'hidden',...style}}><div style={{height:'100%',width:`${Math.max(0,Math.min(100,pct))}%`,background:color||T.blue,borderRadius:99,transition:'width .4s ease'}}/></div>;
export const Btn=({children,primary,small,green,onClick,disabled,style={},...p})=><button onClick={onClick} disabled={disabled} style={{padding:small?'6px 14px':'10px 20px',borderRadius:8,border:`1px solid ${primary?'transparent':green?T.greenD:T.borderMid}`,background:primary?`linear-gradient(135deg,${T.blueD},${T.blue})`:green?`rgba(26,122,80,.15)`:'transparent',color:primary?'#fff':green?T.green:T.textSecond,fontSize:small?12:13,fontWeight:600,cursor:disabled?'not-allowed':'pointer',opacity:disabled?.6:1,fontFamily:"'DM Sans',sans-serif",transition:'all .15s',...style}} {...p}>{children}</button>;
export const CheckBtn=({done,onClick})=><button onClick={onClick} style={{width:22,height:22,borderRadius:6,border:`1.5px solid ${done?T.green:T.borderMid}`,background:done?`rgba(26,122,80,.2)`:'transparent',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,transition:'all .15s'}}>{done&&<span style={{color:T.green,fontSize:13,fontWeight:700}}>✓</span>}</button>;
export const Pill=({children})=><span style={{fontSize:10,padding:'2px 7px',borderRadius:4,background:T.bgPanel2,color:T.textMuted,border:`1px solid ${T.borderFaint}`,whiteSpace:'nowrap'}}>{children}</span>;
export const NUM=({children,size=24,color})=><div style={{fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:size,color:color||T.textPrimary,lineHeight:1,letterSpacing:'-0.5px'}}>{children}</div>;
export const Grid2=({children,style={}})=><div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,...style}}>{children}</div>;
export const Grid4=({children,style={}})=><div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8,...style}}>{children}</div>;
export const Spinner=()=><div style={{display:'flex',justifyContent:'center',padding:40}}><div style={{width:24,height:24,border:`2px solid ${T.borderFaint}`,borderTop:`2px solid ${T.blue}`,borderRadius:'50%',animation:'spin 1s linear infinite'}}/></div>;
export const StatCard=({label,value,sub,color,onClick})=><div onClick={onClick} style={{background:T.bgPanel2,borderRadius:10,padding:'12px 14px',cursor:onClick?'pointer':'default'}}><div style={{fontSize:10,color:T.textMuted,textTransform:'uppercase',letterSpacing:'.1em',marginBottom:6}}>{label}</div><div style={{fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:22,color:color||T.textPrimary,lineHeight:1,marginBottom:sub?4:0}}>{value}</div>{sub&&<div style={{fontSize:11,color:T.textMuted}}>{sub}</div>}</div>;
